var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 11,
    r: 10.5,
    stroke: "black"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.1729 5.20312L12.0586 14.3877H10.5908L10.4678 5.20312H12.1729ZM10.415 17.1826C10.415 16.9189 10.4941 16.6963 10.6523 16.5146C10.8164 16.333 11.0566 16.2422 11.373 16.2422C11.6836 16.2422 11.9209 16.333 12.085 16.5146C12.2549 16.6963 12.3398 16.9189 12.3398 17.1826C12.3398 17.4346 12.2549 17.6514 12.085 17.833C11.9209 18.0146 11.6836 18.1055 11.373 18.1055C11.0566 18.1055 10.8164 18.0146 10.6523 17.833C10.4941 17.6514 10.415 17.4346 10.415 17.1826Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.c1cb7778c97cd1ca4c11154f4753a2ba.svg";
export { ForwardRef as ReactComponent };